import React from 'react';
import Modal from 'react-modal';
import {vtmT} from '../i18n';
import '../../styles/vtm/roll.css';

/** Confirmation d'une action irréversible (archivage), dans le style Elysium. */
const VtmConfirmModal = ({isOpen, title, message, confirmLabel, onConfirm, onCancel}) => (
  <Modal isOpen={isOpen} onRequestClose={onCancel} className="vtmModal" overlayClassName="vtmModalOverlay" contentLabel={title}>
    <div className="vtmModalHeader">
      <h2 className="vtmModalTitle">{title}</h2>
    </div>
    <p className="vtmModalHint">{message}</p>
    <div className="vtmModalActions">
      <button type="button" className="vtmButton primary" onClick={onConfirm}>{confirmLabel}</button>
      <button type="button" className="vtmButton ghost" onClick={onCancel}>{vtmT('cancel')}</button>
    </div>
  </Modal>
);

export default VtmConfirmModal;
